import React from "react";
import ReactDOM from "react-dom/client";
import { Buffer } from "buffer";
import { QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { queryClient } from "@/lib/queryClient";
import { initSentry, reactRootErrorHandlers } from "@/lib/sentry";

// No-op unless REACT_APP_SENTRY_DSN was provided at build time.
const sentryEnabled = initSentry();

if (typeof window !== "undefined" && !window.Buffer) {
  window.Buffer = Buffer;
}
if (typeof window !== "undefined" && !window.global) {
  window.global = window;
}

const rootElement = document.getElementById("root");
// Nginx may inject a factual SEO fallback inside #root before JS runs.
// Critical CSS in index.html clips it from first paint; clear it before mount.
rootElement.replaceChildren();
const root = ReactDOM.createRoot(rootElement, sentryEnabled ? reactRootErrorHandlers() : undefined);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
